import React, { useEffect, useState, useRef } from "react";
import useHttp from "../../../hooks/use-http";
import numberToWords from "number-to-words";
import { toast } from "react-toastify";
import moment from "moment";
import Modal from "react-modal";

const BillOfExchangeForm = (props) => {
  const frmRef = useRef({});

  const addressRef = useRef({});
  const [addressDetails, setAddressDetails] = useState([]);
  const [addressClose, setAddressClose] = useState(false);

  const refNumberRef = useRef({});
  const [rnClose, setRnClose] = useState(false);
  const [rnDetails, setRnDetails] = useState([]);

  const [customerlist, setcustomerlist] = useState([]);
  const [customerId, setcustomerId] = useState([]);
  const [commercialInvoiceId, setCommercialInvoiceId] = useState();
  const [commercialInvoiceList, setCommercialInvoiceList] = useState([]);
  const [profarmaInvoiceId, setprofarmaInvoiceId] = useState();
  const [dndId, setdndId] = useState();

  const currentDate = new Date().toISOString().slice(0, 10);

  const [selectedDate, setSelectedDate] = useState(
    new Date().toISOString().substr(0, 10)
  );

  const handleDateChange = (e) => {
    setSelectedDate(e.target.value);
  };

  const { sendRequest: getcustomer } = useHttp();

  useEffect(() => {
    getcustomer(
      {
        url: `/api/customer/?orgId=${localStorage.getItem("orgId")}`,
      },
      (data) => {
        //console.log("customer", data[0].name);
        setcustomerlist(data);
      }
    );
  }, [getcustomer]);

  const { sendRequest: getCommercialInvoiceData } = useHttp();

  const loadCommercialInvoiceData = (id) => {
    setcustomerId(id);
    getCommercialInvoiceData(
      {
        url: `/api/commercialInvoice/?customerId=${id}`,
      },
      (res) => {
        //console.log("loadCommercialInvoiceData", res);
        setCommercialInvoiceList(res);
      }
    );
  };

  const loadcommercialInvoiceData = (id) => {
    setCommercialInvoiceId(id);

    var itemfilter = commercialInvoiceList.filter(
      (item) => item.commercialInvoiceId == id
    );
    var item = itemfilter[0];
    //console.log(item);
    if (item) {
      frmRef.current.amt_in_figures.value = item.consignmentTotal; //consignmentTotal;
      const totalCostInWords = numberToWords.toWords(item.consignmentTotal);
      frmRef.current.amt_chargeable.value = totalCostInWords;

      setAddressDetails(item.buyerDetails);
      frmRef.current.currency.value=item.currencyName;

      setprofarmaInvoiceId(item.profarmaInvoiceId);

      setcustomerId(item.customerId);

      frmRef.current.date_of_issue.value = moment(item.dateOfIssue).format(
        "YYYY-MM-DD"
      );

      setRnDetails(item.referenceNo);
    }
  };

  const { sendRequest: postBillOfExchange } = useHttp();

  const submitHandler = (e) => {
    e.preventDefault();
    const data = {
      date: moment(frmRef.current.date.value).format("DD/MM/YYYY"),
      customerId: customerId,
      commercialInvoiceId: commercialInvoiceId,
      bLDate: moment(frmRef.current.bill_date.value).format("DD/MM/YYYY"),
      placeOfIssue: frmRef.current.place_of_issue.value,
      dateOfIssue: moment(frmRef.current.date_of_issue.value).format(
        "DD/MM/YYYY"
      ),
      referenceNo: "rnDetails",
      at: frmRef.current.at.value,
      payToTheOrderOf: frmRef.current.pay_to_order.value,
      amtInFigures: frmRef.current.amt_in_figures.value,
      currency: frmRef.current.currency.value,
      amtChargable: frmRef.current.amt_chargeable.value,
      drawnUnder: frmRef.current.drawn_under.value,
      dated: moment(frmRef.current.dated.value).format("DD/MM/YYYY"),
      issuedBy: frmRef.current.issued_by.value,
      drawerDetails: addressDetails,
      remark: frmRef.current.remark.value,
      createdBy: parseInt(localStorage.getItem("id")),
      orgId: localStorage.getItem("orgId"),
      status: 1,
      warehouseId: localStorage.getItem("warehouseId"),
    };
    //console.log(data);
    if (props.update) {
      data["billOfExchangeId"] = props.update.billOfExchangeId;
    }
    postBillOfExchange(
      {
        url: "/api/billOfExchange/",
        method: props.update ? "PUT" : "POST",
        body: data,
      },
      (data) => {
        //console.log(data);
        toast.success(
          `Bill Of Exchange ${props.update ? "Updated" : "Added"}`
        );
        props.addForm(false);
      }
    );
  };
  useEffect(() => {
    //console.log(props.update);
    if (props.update) {
      frmRef.current.date.value = moment(props.update.date).format(
        "YYYY-MM-DD"
      );

     setcustomerId(props.update.customerId);

      frmRef.current.bill_date.value = moment(props.update.bLDate).format(
        "YYYY-MM-DD"
      );

      frmRef.current.place_of_issue.value = props.update.placeOfIssue;
      frmRef.current.date_of_issue.value = moment(
        props.update.dateOfIssue
      ).format("YYYY-MM-DD");

      setRnDetails(props.update.referenceNo);
      frmRef.current.at.value = props.update.at || "";
      frmRef.current.pay_to_order.value = props.update.payToTheOrderOf;
      frmRef.current.amt_in_figures.value = props.update.amtInFigures;
      frmRef.current.currency.value = props.update.currency;
      frmRef.current.amt_chargeable.value = props.update.amtChargable;
      frmRef.current.drawn_under.value = props.update.drawnUnder;
      frmRef.current.dated.value = moment(props.update.dated).format(
        "YYYY-MM-DD"
      );
      frmRef.current.issued_by.value = props.update.issuedBy;
      setAddressDetails(props.update.drawerDetails);
      frmRef.current.remark.value = props.update.remark;
    }
  }, [props.update]);

  const submitAddress = (e) => {
    e.preventDefault();
    setAddressDetails((x) => [
      ...x,
      {
        srno:
          addressDetails.length > 0
            ? addressDetails[addressDetails.length - 1].srno + 1
            : 1,
        partyType: addressRef.current.party_type.value,
        name: addressRef.current.name.value,
        email: addressRef.current.email.value,
        contactNumber: addressRef.current.contact_number.value,
        contactPersonName: addressRef.current.contact_person_name.value,
        landmark: addressRef.current.landmark.value,
        city: addressRef.current.city.value,
        state: addressRef.current.state.value,
        zipcode: addressRef.current.zipcode.value,
        country: addressRef.current.country.value,
      },
    ]);
    //console.log(addressDetails);
  };
  const handleAddressDelete = (index, e) => {
    setAddressDetails(addressDetails.filter((v, i) => i !== index));
  };

  const submitRefNum = (e) => {
    e.preventDefault();
    setRnDetails([
      {
        shipperReferenceNumber: refNumberRef.current.shipp_ref_number.value,
        buyerReferenceNumber: refNumberRef.current.buy_ref_number.value,
        isSave: true,
      },
    ]);

    //console.log(rnDetails);
    setRnClose(false);
  };
  const modalStyles = {
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(0, 0, 0, 0.75)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 10,
    },
    content: {
      backgroundColor: "#fff",
      padding: "20px",
      top: "20%",
      left: "25%",
      borderRadius: "5px",
      maxWidth: "800px",
      maxHeight: "auto",
      height: "400px",
      width: "100%",
      boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
    },
  };
  const modalStyles2 = {
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(0, 0, 0, 0.75)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 10,
    },
    content: {
      backgroundColor: "#fff",
      padding: "20px",
      top: "20%",
      left: "25%",
      borderRadius: "5px",
      maxWidth: "300px",
      maxHeight: "auto",
      height: "300px",
      width: "100%",
      boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
    },
  };
  return (
    <>
      <div className="content-wrapper">
        <section className="content">
          <div className="container-fluid">
            <div className="card card-default">
              <form onSubmit={submitHandler}>
                <div className="card-header">
                  <h3 className="card-title">Bill Of Exchange Form</h3>
                  <div className="card-tools">
                    <button
                      type="button"
                      className="btn btn-tool"
                      data-card-widget="remove"
                      onClick={() => props.addForm(false)}
                    >
                      <i className="fas fa-times" />
                    </button>
                  </div>
                </div>
                <div className="card-body">
                  <div className="row mb-2">
                    <div className="col-md-3">
                      <label htmlFor={"date"}>{"Date "}</label>
                      <input
                        type={"date"}
                        id={"date"}
                        required
                        ref={(el) => (frmRef.current["date"] = el)}
                        className="form-control"
                        max={currentDate}
                        value={selectedDate}
                        onChange={handleDateChange}
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"customer_name"}>{"Customer Name"}</label>
                      <select
                        id="customer_name"
                        className="form-control dropdowns"
                        ref={(el) => (frmRef.current["customer_name"] = el)}
                        value={customerId}
                        onChange={(e) => {
                          loadCommercialInvoiceData(e.target.value);
                        }}
                      >
                        <option>Select</option>
                        {customerlist &&
                          customerlist.map((x) => (
                            <option
                              key={x.customerId}
                              Customer-id={x.customerId}
                              value={x.customerId}
                            >
                              {x.name + "(" + x.customerCode + ")"}
                            </option>
                          ))}
                      </select>
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"commercial_invoice_number"}>
                        {"Commercial Invoice id/Number"}
                      </label>

                      <select
                        id="commercialInvoiceId"
                        className="form-control dropdowns"
                        ref={(el) =>
                          (frmRef.current["commercialInvoiceId"] = el)
                        }
                        value={commercialInvoiceId}
                        onChange={(e) => {
                          setCommercialInvoiceId(e.target.value);
                          loadcommercialInvoiceData(e.target.value);
                        }}
                      >
                        <option value="0">Select</option>
                        {commercialInvoiceList &&
                          commercialInvoiceList.map((x) => (
                            <option
                              key={x.commercialInvoiceId}
                              commercialInvoice-id={x.commercialInvoiceId}
                              value={x.commercialInvoiceId}
                            >
                              {x.commercialInvoiceNo}
                            </option>
                          ))}
                      </select>
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"bill_date"}>
                        {"B/L Date(if Applicable)"}
                      </label>
                      <input
                        type={"date"}
                        id={"bill_date"}
                        required
                        ref={(el) => (frmRef.current["bill_date"] = el)}
                        className="form-control"
                      />
                    </div>
                  </div>
                  <div className="row mb-2">
                    <div className="col-md-3">
                      <label htmlFor={"place_of_issue"}>
                        {"Place of Issue "}
                      </label>
                      <input
                        type={"text"}
                        id={"place_of_issue"}
                        required
                        ref={(el) => (frmRef.current["place_of_issue"] = el)}
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"date_of_issue"}>{"Date of Issue"}</label>
                      <input
                        type={"date"}
                        id={"date_of_issue"}
                        required
                        ref={(el) => (frmRef.current["date_of_issue"] = el)}
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"reference_numbers"}>
                        {"Reference Numbers"}
                      </label>
                      <br />
                      <button
                        type={"button"}
                        autoComplete="off"
                        ref={(el) => (frmRef.current["reference_numbers"] = el)}
                        className="btn btn-sm btn-warning"
                        onClick={() => {
                          setRnClose(true);
                        }}
                      >
                        Add
                      </button>
                    </div>

                    <div className="col-md-3">
                      <label htmlFor={"at"}>{"At"}</label>
                      <input
                        type={"text"}
                        id={"at"}
                        required
                        ref={(el) => (frmRef.current["at"] = el)}
                        className="form-control"
                      />
                    </div>
                  </div>
                  <div className="row mb-2">
                    <div className="col-md-3">
                      <label htmlFor={"pay_to_order"}>
                        {"Pay to the order of"}
                      </label>
                      <input
                        type={"text"}
                        id={"pay_to_order"}
                        required
                        ref={(el) => (frmRef.current["pay_to_order"] = el)}
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"amt_in_figures"}>
                        {"Amount In Figures"}
                      </label>
                      <input
                        type={"text"}
                        id={"amt_in_figures"}
                        required
                        ref={(el) => (frmRef.current["amt_in_figures"] = el)}
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"currency"}>{"Currency"}</label>
                      <input
                        type={"text"}
                        id={"currency"}
                        readOnly
                        required
                        ref={(el) => (frmRef.current["currency"] = el)}
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"amt_chargeable"}>
                        {"Amount Chargeable"}
                      </label>
                      <input
                        type={"text"}
                        id={"amt_chargeable"}
                        required
                        ref={(el) => (frmRef.current["amt_chargeable"] = el)}
                        className="form-control"
                      />
                    </div>
                  </div>
                  <div className="row mb-2">
                    <div className="col-md-3">
                      <label htmlFor={"drawn_under"}>{"Drawn under "}</label>
                      <input
                        type={"text"}
                        id={"drawn_under"}
                        required
                        ref={(el) => (frmRef.current["drawn_under"] = el)}
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"dated"}>{"Dated"}</label>
                      <input
                        type={"date"}
                        id={"dated"}
                        required
                        ref={(el) => (frmRef.current["dated"] = el)}
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"issued_by"}> {"Issued By"}</label>
                      <input
                        type={"text"}
                        id={"issued_by"}
                        required
                        ref={(el) => (frmRef.current["issued_by"] = el)}
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"drawer_details"}>
                        {"Drawee/Drawer Details"}
                      </label>
                      <br />
                      <button
                        className="btn btn-sm btn-success"
                        formNoValidate="True"
                        onClick={(e) => {
                          e.preventDefault(false);
                          addressDetails &&
                            setAddressDetails((items) =>
                              items.filter((x) => x.isSave)
                            );
                          setAddressClose(true);
                        }}
                      >
                        Add
                      </button>
                    </div>
                  </div>
                  <div className="row mb-2">
                    <div className="col-md-3">
                      <label htmlFor={"remark"}>{"Remark/Note"}</label>
                      <input
                        type={"text"}
                        id={"remark"}
                        required
                        ref={(el) => (frmRef.current["remark"] = el)}
                        className="form-control"
                      />
                    </div>
                  </div>

                  <div className=" text-right">
                    <button type="submit" className="btn btn-primary">
                      Submit
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </section>
      </div>
      {/* address modal */}
      {addressClose && (
        <Modal isOpen={true} style={modalStyles}>
          <div className="">
            <h3 className="card-title"> Drawee/Drawer Details</h3>
            <div className="card-tools text-right">
              <button
                type="button"
                className="btn btn-tool"
                data-card-widget="remove"
                onClick={() => setAddressClose(false)}
              >
                <i className="fas fa-times" />
              </button>
              <hr />
            </div>
          </div>
          <div className="row mb-2">
            <div className="col-md-3">
              <label htmlFor={"party_type"}>{"Party Type"}</label>
              <select
                className="form-control"
                ref={(el) => (addressRef.current["party_type"] = el)}
                autoComplete="off"
              >
                <option value="Drawee">Drawee</option>
                <option value="Drawer">Drawer</option>
              </select>
            </div>
            <div className="col-md-3">
              <label htmlFor={"name"}>Name</label>
              <input
                type={"input"}
                id={"name"}
                required
                ref={(el) => (addressRef.current["name"] = el)}
                className="form-control"
              />
            </div>
            <div className="col-md-3">
              <label htmlFor={"email"}>Email id</label>
              <input
                type={"input"}
                id={"email"}
                required
                ref={(el) => (addressRef.current["email"] = el)}
                className="form-control"
              />
            </div>
            <div className="col-md-3">
              <label htmlFor={"contact_person_name"}>contact Person Name</label>
              <input
                type={"input"}
                id={"contact_person_name"}
                required
                ref={(el) => (addressRef.current["contact_person_name"] = el)}
                className="form-control"
              />
            </div>
          </div>
          <div className="row mb-2">
            <div className="col-md-3">
              <label htmlFor={"contact_number"}>Contact Number</label>
              <input
                type={"input"}
                id={"contact_number"}
                required
                ref={(el) => (addressRef.current["contact_number"] = el)}
                className="form-control"
              />
            </div>
            <div className="col-md-3">
              <label htmlFor={"landmark"}>Address(landmark)</label>
              <input
                type={"input"}
                id={"landmark"}
                required
                ref={(el) => (addressRef.current["landmark"] = el)}
                className="form-control"
              />
            </div>
            <div className="col-md-3">
              <label htmlFor={"city"}>City</label>
              <input
                type={"input"}
                id={"city"}
                required
                ref={(el) => (addressRef.current["city"] = el)}
                className="form-control"
              />
            </div>
            <div className="col-md-3">
              <label htmlFor={"state"}>State</label>
              <input
                type={"input"}
                id={"state"}
                required
                ref={(el) => (addressRef.current["state"] = el)}
                className="form-control"
              />
            </div>
          </div>
          <div className="row mb-2">
            <div className="col-md-3">
              <label htmlFor={"zipcode"}>Zip Code</label>
              <input
                type={"text"}
                id={"zipcode"}
                required
                ref={(el) => (addressRef.current["zipcode"] = el)}
                className="form-control"
              />
            </div>

            <div className="col-md-3">
              <label htmlFor={"country"}>Country</label>
              <input
                type={"text"}
                id={"country"}
                required
                ref={(el) => (addressRef.current["country"] = el)}
                className="form-control"
              />
            </div>
            <div className="col-md-3">
              <br />
              <button
                className="btn-sm btn btn-secondary"
                onClick={submitAddress}
              >
                +
              </button>
            </div>
          </div>

          <hr />

          <table className="table table-sm table-bordered table-responsive ">
            {" "}
            <thead>
              <tr>
                <th>Sr. No</th>
                <th>Party Type</th>
                <th>Name</th>
                <th>Email</th>
                <th>contact Person Name</th>
                <th>Contact Number</th>
                <th>Address(landmark)</th>
                <th>City</th>
                <th>State/Province/region</th>
                <th>Zip Code</th>
                <th>Country</th>
                <th>Delete</th>
              </tr>
            </thead>
            <tbody>
              {addressDetails &&
                addressDetails.map((itm, i) => {
                  return (
                    <tr key={i}>
                      <td>{itm.srno}</td>
                      <td>{itm.partyType}</td>
                      <td>{itm.name}</td>
                      <td>{itm.email}</td>
                      <td>{itm.contactPersonName}</td>
                      <td>{itm.contactNumber}</td>
                      <td>{itm.landmark}</td>
                      <td>{itm.city}</td>
                      <td>{itm.state}</td>
                      <td>{itm.zipcode}</td>
                      <td>{itm.country}</td>

                      <td>
                        {" "}
                        <button
                          className="btn"
                          onClick={(e) => handleAddressDelete(i, e)}
                        >
                          <i className="fa fa-trash"></i>
                        </button>
                      </td>
                    </tr>
                  );
                })}
            </tbody>
          </table>

          <div className="text-center">
            <button
              className="btn btn-sm btn-primary"
              onClick={() => {
                addressDetails.map((x) => (x["isSave"] = true));
                setAddressClose(false);
              }}
            >
              Save
            </button>
          </div>
        </Modal>
      )}
      {/* end address modal */}
      {/*reference_numbers modal */}
      {rnClose && (
        <Modal isOpen={true} style={modalStyles2}>
          <div className="">
            <div className="">
              <h3 className="card-title">Reference Numbers Details</h3>
              <div className="card-tools text-right">
                <button
                  type="button"
                  className="btn btn-tool"
                  data-card-widget="remove"
                  onClick={() => setRnClose(false)}
                >
                  <i className="fas fa-times" />
                </button>
                <hr />
              </div>
            </div>
            <div className="row mb-2">
              <div className="col-md-12">
                <label htmlFor={"shipp_ref_number"}>
                  Shipper Reference No{" "}
                </label>
                <input
                  type={"input"}
                  id={"shipp_ref_number"}
                  required
                  ref={(el) => (refNumberRef.current["shipp_ref_number"] = el)}
                  className="form-control"
                />
              </div>
            </div>

            <div className="row mb-2">
              <div className="col-md-12">
                <label htmlFor={"buy_ref_number"}>Buyer Reference No</label>
                <input
                  type={"input"}
                  id={"buy_ref_number"}
                  required
                  ref={(el) => (refNumberRef.current["buy_ref_number"] = el)}
                  className="form-control"
                />
              </div>
            </div>

            <div className="text-center">
              <button className="btn btn-sm btn-primary" onClick={submitRefNum}>
                Save
              </button>
            </div>
          </div>
        </Modal>
      )}
    </>
  );
};

export default BillOfExchangeForm;
